import { apiGet } from './api-utils';
import { IITAPISResult, IResult } from '../models/result-models';
import { IShippingMethods, IUpdateShippingMethod } from '../models/shipping';

const baseUrl = process.env.REACT_APP_API_URL + '/v1/order';

export const getShippingMethods = async (
    billTo: string,
    shipTo: string
): Promise<IResult<IShippingMethods[]>> => {
    const url = `${baseUrl}/shippingMethods/${billTo}/${shipTo}`;
    const result = apiGet<IShippingMethods[]>(url);
    return result;
};

export const updateShippingMethod = async (
    updatedShippingMethod: IUpdateShippingMethod
): Promise<IResult<IITAPISResult>> => {
    const url = `${baseUrl}/changeShippingMethod/${updatedShippingMethod.orderNumber}/${updatedShippingMethod.defaultShippingMethodCode}`;
    const result = apiGet<IITAPISResult>(url);
    return result;
};
